import { useIsCompactLayout } from './useResponsiveLayout';

/**
 * @deprecated Use useIsCompactLayout() or useIsBelowBreakpoint('md').
 */
export function useIsSmallDevice() {
  return useIsCompactLayout();
}
